export default __webpack_public_path__ + "static/media/861fd9c402fa5ada8f9336c869316d28.svg";